import { Component, Input, AfterViewInit, OnInit, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";

declare var $: any;
declare var echarts: any;

@Component({
	selector: 'app-app-audio-play',
	templateUrl: './app-audio-play.component.html',
	styleUrls: ['./app-audio-play.component.css']
})
export class AppAudioPlayComponent implements OnInit, AfterViewInit {
	@HostListener('window:popstate', ['$event']) onPopState() {
		if(this.audioObj) {
			this.audioObj.pause();
		}
	}
	@Input() audioList: any;
	//当前播放信息
	currentAudio: any;
	//当前播放对象
	audioObj: any;
	//当前播放索引
	currentIndex: number = 0;
	//播放进度
	audioProcess: number = 0;
	//显示播放时长
	audioProcessTimes: string = "0:00/0:00";
	//播放状态
	playStatus: boolean = false;
	//第一次播放
	firstPlay: boolean = true;
	//是否显示 tool bar
	showToolBar: boolean = false;
	//当前显示模式
	showTextModel: string = "day";
	//弹窗提示
	showTipEnable: boolean = false;
	//显示加载提示
	showLoading:boolean = false;
	//报告信息
	report: any;

	surveyMetaId: number;
	surveyId: number;
	learningPathOrLearningTourId: number;
	method: number;
	constructor(private commonService: CommonService,
		private apiService: ApiService,
		private route: ActivatedRoute,
		private router: Router,
		private el: ElementRef) {}

	ngOnInit() {
		this.route.params.subscribe(params => {
			this.surveyMetaId = params['surveyMetaId'];
			this.learningPathOrLearningTourId = params['learningPathOrLearningTourId'];
			this.method = params['method'];
			this.surveyId = params['surveyId'];
			this.currentIndex = params['audioIndex'];
		});

		this.getAudioListInfo().subscribe(result => {

			this.audioList = result;
			if(this.audioList.length > 0) {
				this.currentAudio = this.audioList[this.currentIndex];
				setTimeout(() => {
					this.audioInit();
					this.audioObj.src = this.currentAudio.audioUrl;
				}, 300);
			}

		});

		this.getReport();
	}

	audioInit() {
		this.audioObj = this.el.nativeElement.querySelector("audio");
	}

	ngAfterViewInit() {
		this.commonService.initPage();
	}
	//播放音频
	playAudio() {
		if(!this.playStatus) {
			this.audioObj.play();
		} else {
			this.audioObj.pause();
		}
	}
	/* 播放进度 */
	timeupdate() {
		if(this.touchEnable) {
			return false;
		}
		let currentaudio = this.audioObj;
		if(!currentaudio.duration) {
			return false;
		}
		let audioAllTime = currentaudio.duration;
		this.updateProcessUI(currentaudio.currentTime, audioAllTime);
	}
	updateProcessUI(currentTime, AllTimes) {
		this.audioProcess = currentTime * 100 / AllTimes;
		this.audioProcessTimes = this.getTimeformat(currentTime) + "/" + this.getTimeformat(AllTimes);
	}
	/* 进度直接移到当前播放位置 */
	moveCurrentTimes() {
		if(!this.audioObj.duration) {
			return false;
		}
		this.audioObj.currentTime = this.currentAudio.currentTime;
		this.updateProcessUI(this.audioObj.currentTime, this.audioObj.duration);
	}
	/* 播放事件 */
	play() {
		this.playStatus = true;
	}
	/* 暂停事件 */
	pause() {
		this.playStatus = false;
		this.showLoading = false;
	}
	/* 播放完毕 */
	ended() {
		this.showLoading = false;
		this.playStatus = false;
		this.currentAudio.currentTime = 0;
		//播放下一条
		this.playNext();
	}
	/* 正常播放 */
	canplaythrough(){
		this.showLoading = false;
	}
	/* 加载音频中... */
	warting(){
		this.showLoading = false;
	}
	/* 元数据加载完成 */
	loadeddata() {
		this.timeupdate();
		this.moveCurrentTimes();
		if(!this.firstPlay) {
			this.audioObj.play();
		}
	}
	/* 前进 */
	forward() {
		if(!this.playStatus) {
			return false;
		}
		if(this.audioObj.currentTime + 15 >= this.audioObj.duration) {
			this.audioObj.currentTime = this.audioObj.duration;
		} else {
			this.audioObj.currentTime = this.audioObj.currentTime + 15;
		}
	}
	/* 后退 */
	fallback() {
		if(!this.playStatus) {
			return false;
		}
		if(this.audioObj.currentTime - 15 < 0) {
			this.audioObj.currentTime = 0;
		} else {
			this.audioObj.currentTime = this.audioObj.currentTime - 15;
		}
	}
	/* 下一个 */
	playNext() {
		if(this.currentIndex < this.audioList.length - 1) {
			this.audioObj.pause();
			this.currentIndex++;
			this.currentAudio.currentTime = 0;
			this.currentAudio = this.audioList[this.currentIndex];
			this.audioObj.src = this.currentAudio.audioUrl;
			this.audioObj.play();
			this.saveUserAudioProcess(0, null);
		}
	}
	/* 上一个 */
	playPre() {
		if(this.currentIndex > 0) {
			this.audioObj.pause();
			this.currentIndex--;
			this.currentAudio.currentTime = 0;
			this.currentAudio = this.audioList[this.currentIndex];
			this.audioObj.src = this.currentAudio.audioUrl;
			this.audioObj.play();
			this.saveUserAudioProcess(0, null);
		}
	}
	getTimeformat(timeSeconds) {
		var theTime = timeSeconds; // 秒
		var theTime1 = 0; // 分
		var theTime2 = 0; // 小时
		if(theTime > 60) {
			theTime1 = Math.floor(theTime / 60);
			theTime = Math.floor(theTime % 60);
			if(theTime1 > 60) {
				theTime2 = Math.floor(theTime1 / 60);
				theTime1 = Math.floor(theTime1 % 60);
			}
		}
		var result = "" + Math.floor(theTime);
		if(theTime < 10) {
			result = "0" + result;
		}
		if(theTime1 > 0) {
			result = "" + Math.floor(theTime1) + ":" + result;
		} else {
			result = "0:" + result;
		}
		if(theTime2 > 0) {
			result = "" + Math.floor(theTime2) + ":" + result;
		}
		return result;
	}
	/* 获取播放列表 */
	getAudioListInfo() {
		return this.apiService.ajax({
			"type": "get",
			"url": 'sr/coursedna/queryCourseDNAList'
		});
	}
	/* 保存用户播进度 */
	saveUserAudioProcess(currentTime, callback) {
		this.apiService.ajax({
			"type": "post",
			"url": 'sr/coursedna/saveDNAUserAudioRecord/' + this.currentAudio.unitId + '/' + Math.floor(currentTime)
		}).subscribe(() => {
			if(callback) {
				callback();
			}
		});
	}
	/* 切换显示模式 */
	switchShowModel() {
		this.showTextModel = this.showTextModel == "day" ? "night" : "day";
	}
	//最近一次 scrolll top 值
	lastScrollTop: number = 0;
	onScroll($event) {
		this.showToolBar = this.lastScrollTop < $event.srcElement.scrollTop
		this.lastScrollTop = $event.srcElement.scrollTop;
	}
	/* 退出播放器 */
	exitAudio() {
		this.saveUserAudioProcess(this.audioObj.currentTime, () => {
			let link = ['survey', this.learningPathOrLearningTourId, this.surveyMetaId, this.method];
			this.router.navigate(link);
		});
	}

	closeDialog() {
		this.showTipEnable = false;
	}
	showDialog() {
		this.showTipEnable = true;
	}
	/*读取报告*/
	getReport() {
	    this.apiService.getDNAReport("" + this.surveyId + "").subscribe(report => {
	      this.report = this.resortReportItem(report.details);
	    });
	}
	//兼容显示须序
	resortReportItem(reportItems){
		var newReports = [];
		var nextSort = ["外向","亲和","开放","严谨","情绪稳定"];
		nextSort.forEach((item)=>{
			reportItems.forEach((subItem)=>{
				if(item == subItem.name){
					newReports.push(subItem);
				}
			});
		});
		return newReports;
	}

	//是否touch
	touchEnable: boolean = false;
	touchEnableContent: boolean = false;
	touchX: number = 0;
	touchY: number = 0;
	moveTouchTimes = 0;
	currentProcessWidth: number = 0;
	currentProcessBarWidth: number = 0;
	touchstart($event) {
		this.touchEnable = true;
		this.touchX = $event.touches[0].clientX;
		this.currentProcessWidth = $(this.el.nativeElement.querySelector(".audioPlay-play-wrap")).width();
		this.currentProcessBarWidth = $(this.el.nativeElement.querySelector(".audioPlay-play")).width();
	}
	touchstartContent($event) {
		this.touchEnableContent = true;
		this.touchY = $event.touches[0].clientY;
	}
	touchmove($event) {
		if(this.touchEnable) {
			let moveX = $event.touches[0].clientX - this.touchX;
			let currentaudio = this.audioObj;
			if(!currentaudio.duration) {
				return false;
			}
			let audioAllTime = currentaudio.duration;
			let moveValue = this.currentProcessBarWidth + moveX;
			if(moveValue >= 0 && moveValue <= this.currentProcessWidth) {
				this.moveTouchTimes = audioAllTime * ((this.currentProcessBarWidth + moveX) / this.currentProcessWidth);
				this.updateProcessUI(this.moveTouchTimes, audioAllTime);
			}

		}

		if(this.touchEnableContent) {
			let moveY = $event.touches[0].clientY - this.touchY;
			this.showToolBar = moveY <= 0;
		}
	}
	touchend() {
		this.touchEnable = false;
		this.touchEnableContent = false;
		if(this.moveTouchTimes != 0) {
			this.audioObj.currentTime = this.moveTouchTimes;
			this.moveTouchTimes = 0;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/app-audio-play/app-audio-play.component.ts